import { FC } from 'react';
import SearchLedgerCondition from './SearchLedgerCondition';
import UseSearchLedgerCondition from './UseSearchLedgerCondition';

const SearchLedgerConditionContainer: FC = () => {
  return <SearchLedgerCondition {...UseSearchLedgerCondition()} />;
};

export default SearchLedgerConditionContainer;
